import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiSvgIcon = (baseTheme: Theme): Partial<Components> => ({
  MuiSvgIcon: {
    styleOverrides: {
      root: {
        fill: baseTheme.palette.text.primary,
      },
      colorPrimary: {
        color: baseTheme.palette.svgIcon.main,
      },
    },
  },
});
